//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "AgrMonitoringVigour",
  data() {
    return {
      value1: "",
      url: "",
      srcList: [],
      imgPath: "",
      siteList: [],
      parmy: {
        pageNum: 1,
        pageSize: 28,
        total: 0,
      },
      realData: {
        deviceCode: "-",
        deviceName: "-",
      },
    };
  },
  mounted() {},
  created() {
    this.getListImg();
  },
  methods: {
    getListImg(data) {
      let farmAllData = JSON.parse(sessionStorage.getItem("farmAllData"));
      this.realData = {
        deviceCode: farmAllData.deviceCode,
        deviceName: farmAllData.deviceName,
      };
      let obj = "";
      if (data) {
        obj = data;
      } else {
        obj = {
          deviceCode: this.realData.deviceCode,
          startTime: "",
          endTime: "",
          type: "3",
          currentPage: this.parmy.pageNum,
          pageSize: this.parmy.pageSize,
        }; //1近七天 2近30天 3自定义时间（yyyy-MM-dd）
      }

      this.$http.agrModel.getSiteImage(obj).then((res) => {
        console.log(res);
        if (res.status === "1") {
          console.log(res);
          this.siteList = res.data.content;
          this.parmy.total = res.data.recordTotal;
          this.srcList = [];
          this.siteList.forEach((item, index) => {
            this.srcList.push(item.imgeUrl);
          });
        } else {
          this.$message({
            message: res.errMsg,
            type: "error",
            customClass: "customClass",
          });
        }
      });
    },
    search() {
      this.parmy.pageNum = 1;
      let obj;
      if (this.value1) {
        obj = {
          deviceCode: this.realData.deviceCode,
          startTime: this.value1[0],
          endTime: this.value1[1],
          type: "3",
          currentPage: this.parmy.pageNum,
          pageSize: this.parmy.pageSize,
        };
      } else {
        obj = {
          deviceCode: this.realData.deviceCode,
          startTime: "",
          endTime: "",
          type: "3",
          currentPage: this.parmy.pageNum,
          pageSize: this.parmy.pageSize,
        };
      }

      this.getListImg(obj);
    },
    reset() {
      this.value1 = "";
      this.getListImg();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    timestampToTime_Y(timestamp) {
      var date = new Date(timestamp * 1); //这个是10位数字的转换 如果想要13位数的话需要乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h =
        date.getHours() < 10
          ? "0" + date.getHours() + ":"
          : date.getHours() + ":";
      var m =
        date.getMinutes() < 10
          ? "0" + date.getMinutes() + ":"
          : date.getMinutes() + ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D;
    },
    timestampToTime_H(timestamp) {
      var date = new Date(timestamp * 1); //这个是10位数字的转换 如果想要13位数的话需要乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h =
        date.getHours() < 10
          ? "0" + date.getHours() + ":"
          : date.getHours() + ":";
      var m =
        date.getMinutes() < 10
          ? "0" + date.getMinutes() + ":"
          : date.getMinutes() + ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return h + m + s;
    },
    handleCurrentChange(val) {
      this.parmy.pageNum = val;
      this.getListImg();
    },
  },
};
